import { combineReducers, Reducer } from '@reduxjs/toolkit';
import { reducer as layoutReducer } from './slices/layoutSlice';
import { RootState } from './types';

export const rootReducer: Reducer<RootState> = combineReducers({
  layout: layoutReducer,
});
